import { useEffect, useState } from "react";
import { API_BASE, api } from "@/lib/api";
import { applyDocumentFavicon, resolveBrandingAssetUrl } from "@shared/brandingAssetUrl";

export type CampsiteBranding = {
  siteName: string;
  logoUrl: string | null;
  faviconUrl: string | null;
};

const DEFAULT_BRANDING: CampsiteBranding = {
  siteName: "Campingplatz",
  logoUrl: null,
  faviconUrl: null,
};

export function useCampsiteBranding(): CampsiteBranding {
  const [branding, setBranding] = useState<CampsiteBranding>(DEFAULT_BRANDING);

  useEffect(() => {
    let cancelled = false;
    void api
      .get<{ site_name: string; logo_url: string | null; favicon_url?: string | null }>(
        "/api/v1/public/branding",
      )
      .then((data) => {
        if (cancelled) return;
        const logoUrl = resolveBrandingAssetUrl(data.logo_url, API_BASE);
        setBranding({
          siteName: data.site_name?.trim() || DEFAULT_BRANDING.siteName,
          logoUrl,
          faviconUrl: resolveBrandingAssetUrl(data.favicon_url, API_BASE) ?? logoUrl,
        });
      })
      .catch(() => {
        if (!cancelled) setBranding(DEFAULT_BRANDING);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (branding.siteName !== DEFAULT_BRANDING.siteName) {
      document.title = branding.siteName;
    }
    applyDocumentFavicon(branding.faviconUrl);
  }, [branding]);

  return branding;
}
